import { RoutesInterfaceType } from '@clientos/types';
import { RoutesService } from '../../../services/RoutesService';
import bindAllMethods from '../../../utils/bindAllMethods';
import { getServices } from '../../../infra/startup';

export default class Routes {
  private _routesService: RoutesService;

  constructor() {
    const services = getServices();
    this._routesService = services.routesService;
    bindAllMethods(this);
  }

  public getInterface(): RoutesInterfaceType {
    return {
      getRoutes: this._routesService.getRoutes,
      findRouteByKey: this._routesService.findRouteByKey,
      findRouteByPath: this._routesService.findRouteByPath
    };
  }
}
